// extracted by mini-css-extract-plugin
export var pageContent = "bubblesLayout-module--pageContent--bN41s";
export var pageLayout = "bubblesLayout-module--pageLayout--9VX92";